<div>
  <div class="row justify-content-center">
    <div class="col-md-8">
      <h1>Activation</h1>

      @if (success) {
        <div class="alert alert-success">
          <span
            ><strong>Your user account has been activated.</strong> Please
          </span>
          <a [routerLink]="['/login']" class="alert-link">sign in</a>.
        </div>
      }

      @if (error) {
        <div class="alert alert-danger">
          <strong>Your user could not be activated.</strong>
        </div>
      }
    </div>
  </div>
</div>
